import { Amplify } from "aws-amplify";
import { fetchAuthSession } from "aws-amplify/auth";

export const API_NAME = "BackendAPI";

export function configureAmplify(): void {
  const isLocal =
    import.meta.env.MODE === "localhost" ||
    window.location.hostname === "localhost";
  const redirectUrl = isLocal
    ? `http://localhost:${import.meta.env.VITE_LOCALHOST_FRONTEND_PORT}`
    : import.meta.env.VITE_COGNITO_REDIRECT_URL;
  const apiUrl = isLocal
    ? `http://localhost:${import.meta.env.VITE_LOCALHOST_BACKEND_PORT}`
    : import.meta.env.VITE_API_URL;
  Amplify.configure(
    {
      Auth: {
        Cognito: {
          userPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID,
          userPoolClientId: import.meta.env.VITE_COGNITO_USER_POOL_CLIENT_ID,
          loginWith: {
            oauth: {
              domain: import.meta.env.VITE_COGNITO_OAUTH_DOMAIN,
              scopes: import.meta.env.VITE_COGNITO_OAUTH_SCOPES.split(","),
              redirectSignIn: [redirectUrl],
              redirectSignOut: [redirectUrl],
              responseType: import.meta.env.VITE_COGNITO_RESPONSE_TYPE as
                | "code"
                | "token",
            },
          },
        },
      },
      API: { REST: { [API_NAME]: { endpoint: apiUrl } } },
    },
    {
      API: {
        REST: {
          headers: async ({ apiName }): Promise<Record<string, string>> => {
            const res: Record<string, string> = {};
            if (apiName === API_NAME) {
              const session = await fetchAuthSession();
              const idToken = session.tokens?.idToken;
              if (idToken !== undefined) {
                res.Authorization = idToken.toString();
              }
            }
            return res;
          },
        },
      },
    }
  );
}
